/**
 * This method normalizes object containing list of webinars
 * It returns object containing 2 keys
 * 1st is byKey. This is an object of sessionKey and webinar
 * 2nd is allKeys. This is an array containing all webinarKeys
 *
 * @param entitiesMap
 * @returns {{byKey, allKeys}}
 */

import { denormalize, normalize, schema } from 'normalizr';
const webinar = new schema.Entity('webinars', {}, { idAttribute: 'webinarKey' });
const webinarsSchema = { webinars: [webinar] };

export function normalizeWebinars(webinarsList = []) {
  if (webinarsList.length === 0) {
    return {
      byKey: {},
      allKeys: []
    };
  }
  const { result, entities } = normalize({ webinars: webinarsList }, webinarsSchema);
  return {
    byKey: entities.webinars,
    allKeys: result.webinars
  };
}

/**
 * This method de normalizes webinarsMap for given webinarKeys
 *
 * @param webinarKeys
 * @param webinarsMap
 * @returns [webinars]
 */
export function denormalizeWebinars(webinarKeys, webinarsMap) {
  if (webinarKeys === null || webinarKeys.length === 0) {
    return [];
  }
  const deNormalizedData = denormalize({ webinars: webinarKeys }, webinarsSchema, { webinars: webinarsMap });
  return deNormalizedData.webinars;
}



// WEBPACK FOOTER //
// ./src/Reducks/Webinars/WebinarsUtils.js